// ===========================================================================
// CostCompositionChart — "¿Dónde se va el gasto?". Barras horizontales a medida
// (no dona de librería) por categoría de servicio. Responde la pregunta más
// accionable: qué tipo de servicio atacar.
// ===========================================================================
import React from "react";
import { Box, Paper, Typography, Stack } from "@mui/material";
import { formatCompactCurrency, formatPercent } from "../../utils/format";
import { COST_CATEGORIES } from "../../common/constants";

// Color por categoría (cae a gris si el backend trae un nombre no mapeado).
const colorFor = (category) =>
  COST_CATEGORIES.find((c) => c.label.toLowerCase() === String(category).toLowerCase())?.color || "#90a4ae";

export default function CostCompositionChart({ data }) {
  const rows = Array.isArray(data) ? data : [];
  const maxPct = Math.max(1, ...rows.map((r) => Number(r.pct) || 0));

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, height: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
        Where the money goes
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Cost by service category
      </Typography>

      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          No data available yet.
        </Typography>
      ) : (
        <Stack spacing={1.5} sx={{ mt: 2 }}>
          {rows.map((row) => {
            const pct = Number(row.pct) || 0;
            return (
              <Box key={row.category}>
                <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.4 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {row.category}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontVariantNumeric: "tabular-nums" }}>
                    {formatCompactCurrency(row.cost)} · {formatPercent(pct)}
                  </Typography>
                </Stack>
                <Box sx={{ height: 14, borderRadius: 1, bgcolor: "action.hover", overflow: "hidden" }}>
                  <Box
                    sx={{
                      width: `${(pct / maxPct) * 100}%`,
                      height: "100%",
                      borderRadius: 1,
                      bgcolor: colorFor(row.category),
                      transition: "width 0.4s ease",
                    }}
                  />
                </Box>
              </Box>
            );
          })}
        </Stack>
      )}
    </Paper>
  );
}
